import { EtatJeu, GameData } from './types';
import { genererPermutation, graine, melanger, mulberry32 } from './logic';

const CLE = 'sfg_v1';

export function chargerEtat(): EtatJeu | null {
  try {
    const brut = localStorage.getItem(CLE);
    return brut ? (JSON.parse(brut) as EtatJeu) : null;
  } catch {
    return null;
  }
}

export function sauverEtat(etat: EtatJeu): void {
  localStorage.setItem(CLE, JSON.stringify(etat));
}

export function effacerEtat(): void {
  localStorage.removeItem(CLE);
}

export function creerEtat(prenom: string, data: GameData): EtatJeu {
  const demarreLe = Date.now();
  const ordres: Record<string, number[]> = {};
  data.questions.forEach((q) => {
    const rand = mulberry32(graine(`${prenom}:${demarreLe}:${q.id}`));
    ordres[q.id] = melanger(q.propositions.map((_, i) => i), rand);
  });
  return {
    prenom: prenom.trim(),
    demarreLe,
    permutation: genererPermutation(data.invites, prenom, demarreLe),
    ordresPropositions: ordres,
    questionsOk: [],
    erreursQuestion: {},
    verrouJusqua: null,
    coupsDePouce: [],
    indicesCollectes: [],
    carnet: {},
    serruresOuvertes: [],
    erreursSerrure: {},
    lettresRevelees: {},
    jokerUtilise: false,
    penalitesSec: 0,
    termineLe: null,
    jeton: null,
    scoreEnvoye: false,
    rang: null,
    pseudoFinal: null,
  };
}

export function tempsFinalSec(etat: EtatJeu): number {
  const fin = etat.termineLe ?? Date.now();
  return Math.max(1, Math.floor((fin - etat.demarreLe) / 1000) + etat.penalitesSec);
}
